// Tyler.Api.Metadata.CompareType
export enum CompareType {
    LessThan = 0,
    LessThanOrEqualTo = 1,
    EqualTo = 2,
    GreaterThanOrEqualTo = 3,
    GreaterThan = 4
}
